module.exports = __webpack_public_path__ + "static/img/Ben-Hunt.61f83ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ben-Hunt.jpg
// module id = PQyI
// module chunks = 0